import { Stack } from "@mui/material";

import Datetime from "@/common/components/Datetime/Datetime";
import InlineApiEnumValue from "@/common/components/Enum/InlineApiEnumValue";
import FileListView from "@/common/components/Files/FileListView";
import FieldValue from "@/common/components/Form/Display/FieldValue";
import { ATTACHMENTS_COMMON_ITEM_SIZES } from "@/common/constants/common";
import { FileItem } from "@/common/fileItem";
import { ArrayHelper } from "@/common/helpers/array";
import { ApiEnumName } from "@/common/services/enum";
import { PersonalDataDeletionDto } from "@/core/api/generated/v1";

import GeneralByWhoDisplay from "../../General/Display/GeneralByWhoDisplay";

export interface PersonalDataDeletionDisplayProps {
  value: PersonalDataDeletionDto;
}

export function PersonalDataDeletionDisplay({ value }: PersonalDataDeletionDisplayProps) {
  return (
    <Stack gap={0.5}>
      <FieldValue variant='filled' direction='column' label='Deleted' isEmpty={!value.deletedAt}>
        <Stack direction='row' gap={1} sx={{ alignItems: "center", flexWrap: "wrap" }}>
          {value.deletedBy && <GeneralByWhoDisplay who={{ userId: value.deletedBy }} />}{" "}
          {value.deletedAt && <Datetime datetime={value.deletedAt} withDurationFromNow />}{" "}
        </Stack>
      </FieldValue>

      <FieldValue
        variant='filled'
        direction='column'
        label='Reason type'
        isEmpty={!value.reasonType}
      >
        <InlineApiEnumValue
          type={ApiEnumName.PersonalDataDeletionReasonType}
          value={value.reasonType}
          withHelperTooltip
        />
      </FieldValue>

      <FieldValue variant='filled' direction='column' label='Reason text' isEmpty={!value.reason}>
        {value.reason}
      </FieldValue>

      <FieldValue
        variant='filled'
        direction='column'
        label='Inquiry date'
        isEmpty={!value.inquiryDate}
      >
        <Datetime datetime={value.inquiryDate} withDurationFromNow />
      </FieldValue>

      <FieldValue
        variant='filled'
        direction='column'
        label='Inquiry attachments'
        isEmpty={ArrayHelper.isEmpty(value.inquiryAttachments)}
      >
        <Stack gap={0.5}>
          {value.inquiryAttachments && (
            <FileListView
              files={FileItem.createManyFrom(value.inquiryAttachments)}
              maxVisibleFiles={10}
              itemWidth={ATTACHMENTS_COMMON_ITEM_SIZES.WIDTH}
              itemHeight={ATTACHMENTS_COMMON_ITEM_SIZES.HEIGHT}
            />
          )}
        </Stack>
      </FieldValue>
    </Stack>
  );
}
